import {
  DefaultPage,
  CollectionItems,
  CollectionEdit,
  CreateCollectionItem,
  CollectionItemEdit,
  Constructors,
  DerivedFields,
  Constants,
  Filters,
  Constraints,
  Validations,
  AddCollectionField,
  AddCollectionDerivedField,
  AddCollectionFilter,
  AddItemInCollection,
  ImportCollectionData,
  Workflow,
  CollectionDump,
  CollectionIndex,
  CollectionWithCsv,
  CollectionWithRestApi,
  CollectionDefaultPage,
  ImportCollectionDump,
  CollectionWithJson,
  ImportDataFromJson,
  ImportFromRestApi,
  CreateCollectionWithPostgresql,
  PermissionLevelSecurity,
  ManagePermissions,
  RowLevelSecurity,
  TypesenseMapping,
  CollectionWithPrompt,
  CollectionMapping,
  GoogleCalendarMapping,
  DerivedFieldMapping,
} from './';

export default {
  path: 'collections/:version/v',
  name: 'Collections',
  childRoutes: [
    { path: ':projectId', name: 'Collections List', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/items/:collectionId/name/:collectionName',
      name: 'Collection Data',
      component: CollectionItems,
      isPrivate: true,
    },
    {
      path: ':projectId/edit/:collectionId',
      name: 'Collection edit',
      component: CollectionEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/:collectionId/items/create',
      name: 'Create collection item',
      component: CreateCollectionItem,
      isPrivate: true,
    },
    {
      path: ':projectId/:collectionId/name/:collectionName/items/:itemId/edit',
      name: 'Collection item edit',
      component: CollectionItemEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/constructors/:collectionId',
      name: 'Constructors',
      component: Constructors,
      isPrivate: true,
    },
    {
      path: ':projectId/derived-fields/:collectionId',
      name: 'Derived fields',
      component: DerivedFields,
      isPrivate: true,
    },
    {
      path: ':projectId/constants/:collectionId',
      name: 'Constants',
      component: Constants,
      isPrivate: true,
    },
    {
      path: ':projectId/filters/:collectionId',
      name: 'Filters',
      component: Filters,
      isPrivate: true,
    },
    {
      path: ':projectId/constraints/:collectionId',
      name: 'Constraints',
      component: Constraints,
      isPrivate: true,
    },
    {
      path: ':projectId/validations/:collectionId',
      name: 'Validations',
      component: Validations,
      isPrivate: true,
    },
    {
      path: ':projectId/create',
      name: 'Create collection',
      component: CollectionDefaultPage,
      isPrivate: true,
    },
    {
      path: ':projectId/fields/:collectionId',
      name: 'Add collection field',
      component: AddCollectionField,
      isPrivate: true,
    },
    {
      //TODO: Usage
      path: ':projectId/add-derived-fields/:collectionId',
      name: 'Add collection constructor',
      component: AddCollectionDerivedField,
      isPrivate: true,
    },
    {
      //TODO: Usage
      path: ':projectId/add-filters/:collectionId',
      name: 'Add collection filter',
      component: AddCollectionFilter,
      isPrivate: true,
    },
    {
      //TODO: Usage
      path: ':projectId/add-item/:collectionId',
      name: 'Add data in collection',
      component: AddItemInCollection,
      isPrivate: true,
    },
    {
      path: ':projectId/import-data/:collectionId',
      name: 'Import collection data',
      component: ImportCollectionData,
      isPrivate: true,
    },
    {
      path: ':projectId/workflow/:collectionId',
      name: 'Workflow',
      component: Workflow,
      isPrivate: true,
    },
    {
      path: ':projectId/dump/:collectionId',
      name: 'Collection dump',
      component: CollectionDump,
      isPrivate: true,
    },
    {
      path: ':projectId/indexing/:collectionId',
      name: 'Collection index',
      component: CollectionIndex,
      isPrivate: true,
    },

    {
      path: ':projectId/create-with-csv',
      name: 'Collection via CSV',
      component: CollectionWithCsv,
      isPrivate: true,
    },
    {
      path: ':projectId/create-with-restApi',
      name: 'Collection via REST API',
      component: CollectionWithRestApi,
      isPrivate: true,
    },
    {
      path: ':projectId/import-dump/:collectionId',
      name: 'Import collection dump',
      component: ImportCollectionDump,
      isPrivate: true,
    },
    {
      path: ':projectId/manage-permissions',
      name: 'Manage Permissions',
      component: ManagePermissions,
      isPrivate: true,
    },
    {
      path: ':projectId/create-with-json',
      name: 'Collection with json',
      component: CollectionWithJson,
      isPrivate: true,
    },
    {
      path: ':projectId/import-data-from-json/:collectionId',
      name: 'Import data from json',
      component: ImportDataFromJson,
      isPrivate: true,
    },
    {
      path: ':projectId/import-from-restapi/:collectionId',
      name: 'Import from rest api',
      component: ImportFromRestApi,
      isPrivate: true,
    },
    {
      path: ':projectId/create-with-:dataSourceName',
      name: 'Create collection with postgresql',
      component: CreateCollectionWithPostgresql,
      isPrivate: true,
    },
    {
      path: ':projectId/permission-level-security/:collectionId',
      name: 'Permission Level Security',
      component: PermissionLevelSecurity,
      isPrivate: true,
    },
    {
      path: ':projectId/row-level-security/:collectionId',
      name: 'Row level security',
      component: RowLevelSecurity,
      isPrivate: true,
    },
    {
      path: ':projectId/typesense-mapping/:collectionId',
      name: 'Typesense mapping',
      component: TypesenseMapping,
      isPrivate: true,
    },
    {
      path: ':projectId/create-with-prompt',
      name: 'Collection with prompt',
      component: CollectionWithPrompt,
    },
    {
      path: ':projectId/collection-mapping/:collectionId',
      name: 'Collection Mapping',
      component: CollectionMapping,
      isPrivate: true,
    },
    {
      path: ':projectId/google-calendar-mapping/:collectionId',
      name: 'Google calendar mapping',
      component: GoogleCalendarMapping,
      isPrivate: true,
    },
    {
      path: ':projectId/derived-field-mapping/:collectionId',
      name: 'Derived field mapping',
      component: DerivedFieldMapping,
      isPrivate: true,
    },
  ],
};
